import type { UserProfile } from '../types/user';

// Erlaubte Server-Felder für Quiz-Scores (nur bestehende Felder, keine neuen DB-Spalten)
type ServerField = Extract<keyof UserProfile, `quiz_${number}_${number}`>;

// Mapping: `storageKey` der Quiz-Seite -> Server-Feldname beim User
// Beispiel: 'm1_u1_x99': 'quiz_1_1'
export type QuizServerMap = Record<string, ServerField>;

export const QUIZ_SERVER_MAP: QuizServerMap = {
  // Modul 1 - Lüftung
  'm1_u1_x99': 'quiz_1_1',
  'm1_u2_x99': 'quiz_1_2',
  'm1_u3_x99': 'quiz_1_3',
  
  // Modul 2 - Heizung
  'm2_u1_x99': 'quiz_2_1',
  'm2_u2_x99': 'quiz_2_2',
  'm2_u3_x99': 'quiz_2_3',
  'm2_u4_x99': 'quiz_2_4',
  'm2_u5_x99': 'quiz_2_5',
  
  // Modul 3 - Kältetechnik
  'm3_u1_x99': 'quiz_3_1',
  'm3_u2_x99': 'quiz_3_2',
  'm3_u3_x99': 'quiz_3_3',
  
  // Modul 4 - Elektrotechnik
  'm4_u1_x99': 'quiz_4_1',
  'm4_u2_x99': 'quiz_4_2',
  'm4_u3_x99': 'quiz_4_3',
  'm4_u4_x99': 'quiz_4_4',
  
  // Modul 5 - DDC/SPS
  'm5_u99': 'quiz_5_1',
  
  // Modul 6 - Gerätebau
  'm6_u1_x99': 'quiz_1_4',
  'm6_u2_x99': 'quiz_1_5',
  'm6_u3_x99': 'quiz_5_2',
  'm6_u4_x99': 'quiz_5_3',
  'm6_u5_x99': 'quiz_5_4',
  'm6_u6_x99': 'quiz_5_5',
  'm6_u7_x99': 'quiz_4_5',
};

const QUIZ_KEY_REGEX = /^quiz_\d+_\d+$/;

// Liefert das Server-Feld für ein Quiz:
// 1) Explizit aus QUIZ_SERVER_MAP per storageKey
// 2) Fallback: erstes `quiz_X_Y` aus den sheetCandidates
export const resolveServerQuizId = (
  storageKey: string,
  sheetCandidates: string[]
): ServerField | null => {
  if (storageKey && QUIZ_SERVER_MAP[storageKey as keyof typeof QUIZ_SERVER_MAP]) {
    return QUIZ_SERVER_MAP[storageKey as keyof typeof QUIZ_SERVER_MAP];
  }
  const found = (sheetCandidates || []).find((s) => QUIZ_KEY_REGEX.test(s));
  return (found as ServerField) || null;
};
